<template>
  <div class="precision-drive-scene">
    <!-- 顶部宣传区域 -->
    <div class="top-banner">
      <div class="banner-content">
        <h2 class="title" v-if="newsActivityTitle && newsActivityTitle.title" v-html="newsActivityTitle.title"></h2>
        <h1 class="main-title" v-if="newsActivityTitle && newsActivityTitle.mainTitle" v-html="newsActivityTitle.mainTitle"></h1>
        <div class="icon-list" v-if="newsActivityTitle && newsActivityTitle.content">
          <div class="icon-item">
            <span v-html="newsActivityTitle.content"></span>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <!-- 导航栏 -->
      <el-tabs v-model="activeTab"  class="nav-tabs tabs-item"  @tab-click="handleTabClick">
        <el-tab-pane
            v-for="(item, index) in activeList"
            :key="item.id"
            :label="item.name"
            :name="item.id"
        >
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 展示区域 -->
    <div class="carousel-container">
      <div class="container">
        <el-row :gutter="15">
          <el-col
              :xs="24"
              :sm="12"
              :md="8"
              :lg="6"
              v-for="(product, index) in newActivity"
              :key="index"
          >
            <div class="news-card" @click="goToDetail(product.newActivityId)">
              <img :src="$VUE_APP_BASE_API + product.picture" alt="" class="product-img">
              <div class="xiawenzi">
                <div>
                  <div class="product-name">{{product.title}}</div>
                  <div class="product-detail">{{ stripHtmlTags(product.content) }}</div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import {getNewsActivityList, getNewsActivityFlagList, getNewsActivityTitle} from "@/api/sysytem/homePage";

export default {
  name: 'newsEvents',
  data() {
    return {
      activeTab: '', // 默认选中 tab
      activeList: [], // 动态维护的分类列表
      newActivity: [],
      newsActivityTitle: null, // 新闻活动标题文本
    }
  },
  created() {
    this.init()
  },
  methods: {
    init(){
      // 获取新闻活动标题文本
      getNewsActivityTitle().then(res => {
        if (res && res.code === 200 && res.data) {
          this.newsActivityTitle = res.data;
        }
      }).catch(error => {
        console.error('获取新闻活动标题文本出错:', error);
      });

      // 先获取分类列表
      getNewsActivityFlagList().then(res => {
        if (res && res.code === 200 && res.data && Array.isArray(res.data)) {
          // 将返回的数据映射到 activeList
          this.activeList = res.data.map(item => ({
            id: item.id ? item.id.toString() : item.flagId ? item.flagId.toString() : '',
            name: item.flagName || item.name || ''
          })).filter(item => item.id && item.name); // 过滤掉无效数据
          
          // 设置默认选中的 tab
          if (this.activeList.length > 0) {
            this.activeTab = this.activeList[0].id;
            // 加载默认分类的数据
            this.getNewsActivityList(this.activeTab);
          }
        } else {
          console.error('获取分类列表失败或数据格式不正确:', res);
        }
      }).catch(error => {
        console.error('获取分类列表出错:', error);
      });
    },
    getNewsActivityList(flag) {
      const query = {flag: flag };
      const pageReq = {};
      getNewsActivityList(query, pageReq).then(res => {
        // 根据API返回结构处理数据
        if (res && res.data && Array.isArray(res.data)) {
          this.newActivity = res.data
        } else if (Array.isArray(res)) {
          this.newActivity = res
        } else {
          console.error('数据结构不正确:', res);
          this.newActivity = []
        }
      });
    },
    handleTabClick(tab) {
      this.getNewsActivityList(tab.name)
    },
    goToDetail(newsId) {
      this.$router.push(`/newsEventsDetails/${newsId}`)
    },
    stripHtmlTags(html) {
      if (!html) return '';
      return html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').trim();
    }
  }
}
</script>

<style scoped>
.precision-drive-scene {
  background-color: #000;
  overflow: hidden;
}

/* 公共容器样式 - 实现响应式居中 */
.container {
  width: 100%;
  max-width: 1165px;
  margin: 0 auto;
  padding: 0 15px;
  box-sizing: border-box;
}

/* 顶部宣传区域样式 */
.top-banner {
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  position: relative;
  width: 100%;
  min-height: 360px;
  background-image: url("@/assets/img/news.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.banner-content {
  width: 100%;
  max-width: 1165px;
  padding: 60px 15px;
  box-sizing: border-box;
}

.title {
  font-size: 20px;
  margin: 0 0 8px;
  opacity: 0.8;
}

.main-title {
  font-size: 36px;
  margin: 0 0 16px;
  font-weight: bold;
}

.icon-list {
  display: flex;
  gap: 20px;
}

.icon-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.icon-item i {
  font-size: 24px;
  margin-bottom: 8px;
}

.icon-item span {
  font-size: 12px;
  max-width: 800px;
  color: rgba(255, 255, 255, 0.8);
}

/* 导航栏样式 */
.nav-tabs {
  background-color: #000;
  margin: 20px 0 0;
  font-size: 14px;
  color: #FFFFFF;
}

.tabs-item ::v-deep .el-tabs__item {
  color: #FFFFFF;
  font-size: 24px;
}

.tabs-item ::v-deep .el-tabs__item.is-active {
  color: #1A7AFF;
  border-radius: 4px;
  margin: 0 0 12px;
}

.tabs-item ::v-deep .el-tabs__item:hover:not(.is-active) {
  color: #FFFFFF;
}

.tabs-item ::v-deep .el-tabs__nav-wrap::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2px;
  background-color: #ffffff;
  z-index: 1;
  opacity: 0.4;
}

/* 展示区域样式 */
.carousel-container {
  position: relative;
  width: 100%;
  overflow: hidden;
  background-color: #000;
  padding: 10px 0;
}

/* 新闻卡片样式 */
.news-card {
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-radius: 8px;
  overflow: hidden;
}

.news-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(255, 255, 255, 0.1);
}

/* 产品图片样式 */
.product-img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  vertical-align: middle;
}

/* 文字区域样式 */
.xiawenzi {
  padding: 0 16px;
  background: #000000;
  height: 105px;
}

.product-name {
  font-weight: 700;
  padding-top: 10px;
  padding-bottom: 5px;
  font-size: 16px;
  color: #FFFFFF;
  white-space: nowrap; /* 禁止文本换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  /* display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-wrap: break-word;  */
}

.product-detail {
  font-size: 14px;
  color: #FFFFFF;
  opacity: 0.5;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3; /* 最多显示3行 */
  line-clamp: 3; /* 标准属性 */
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 响应式调整 */
@media screen and (max-width: 1200px) {
  .main-title {
    font-size: 32px;
  }
}

@media screen and (max-width: 992px) {
  .main-title {
    font-size: 28px;
  }

  .icon-item span {
    font-size: 11px;
  }
}

@media screen and (max-width: 768px) {
  .top-banner {
    min-height: 250px;
  }

  .main-title {
    font-size: 24px;
  }

  .title {
    font-size: 18px;
  }

  .xiawenzi {
    height: auto;
    min-height: 105px;
    padding-bottom: 15px;
  }
}

@media screen and (max-width: 576px) {
  .top-banner {
    min-height: 200px;
  }

  .main-title {
    font-size: 20px;
  }

  .title {
    font-size: 16px;
  }

  .product-img {
    height: 160px;
  }

  .icon-item span {
    display: none; /* 小屏幕隐藏详细描述 */
  }
}
</style>
